import { AssetWithSeriesId } from 'types';

import { CollectionAsset, convertRhinoAssetTypeToMediaType } from '@kaltura-ott/tvpil-shared';

import { resolveLinkProgramAsset } from 'components/presenters/Card/helpers';

interface Props {
  data: CollectionAsset;
  isSingleVod: boolean;
  isFutureProgram: boolean;
  collectionType: string | undefined;
  isChannelAsset: boolean;
  isProgramLive: boolean;
}

function useSeriesCatchUpCardLink({ data, isSingleVod, isFutureProgram, collectionType, isChannelAsset, isProgramLive }: Props) {
  const mediaTypeParam = convertRhinoAssetTypeToMediaType(data.type);

  const link = resolveLinkProgramAsset({
    data: data as AssetWithSeriesId,
    collectionType,
    mediaTypeParam,
    isFutureProgram,
    isSingleVod,
    isAsPlayAsset: false,
    isChannelAsset,
    isProgramLive,
  });

  return { link, mediaTypeParam };
}

export { useSeriesCatchUpCardLink };
